import { createReducer, createActions } from "reduxsauce"
import { call, getContext, put, takeEvery } from "redux-saga/effects"
import { get as getApi } from "api"
import { Creators as StaticAlertCreators } from "modules/static-alert/model"
import localStore from "../../../helpers/localStore"
import { Creators as HistoryCreators } from "../../../actions/app/history"
import { Creators as ServerNotificationsCreators } from "../server-notifications/model"

export const { Types, Creators } = createActions({
  loadAccount: ["accountAlias"],
}, {
  prefix: "ompnt/modules/accountRoot/",
})

const DEFAULT_STATE = {}

export default createReducer(DEFAULT_STATE, {})

function* loadAccount({ accountAlias }) {
  const { navigate } = yield getContext("router")
  if (!accountAlias) {
    yield call(navigate, "/404")
  } else {
    try {
      // The meta endpoint is secured with the cookie but not the token
      const account = yield call(getApi, `/api/${accountAlias}/meta`, true)

      if (account) {
        if (account.superuserAccessBlocked) {
          window.location = `/admin/accounts/${account.id}/request-access?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`
        }

        if (account.ipAddressBlocked) {
          // Need to load the page so that pi-server can serve it as it doesn't exist in the app's routes
          window.location = "/ip-restricted"
          return
        }

        yield put(HistoryCreators.selectAccount(account))
        localStore.init(window.localStorage, account.id)
        // Current identification requires a user-account to be set in the context, not only a user
        yield put(HistoryCreators.identify())
        yield put(ServerNotificationsCreators.init())
        if (account.staticAlert) {
          yield put(StaticAlertCreators.setStaticAlert(account.staticAlert))
        }
      } else {
        const { navigate } = yield getContext("router")
        yield call(navigate, "/404")
      }
    } catch {
      yield call(navigate, "/404")
    }
  }
}

export function* saga() {
  yield takeEvery(Types.LOAD_ACCOUNT, loadAccount)
}
